import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Visible tracking notice, required on every page that runs the pixel.
 * Links to the cookie policy, privacy policy, and opt-out pages.
 */
export function TrackingNotice() {
  return <p className="text-xs text-gray-500 leading-relaxed text-center max-w-2xl mx-auto" data-id="element-875" data-mp="18enwm2g8lgd">
      This page uses cookies and tracking pixels to measure advertising
      performance and match you with schools. See our{' '}
      <Link to="/cookie-policy" className="underline hover:text-gray-700" data-id="element-876" data-mp="34qofn72gi1r8">
        Cookie Policy
      </Link>{' '}
      and{' '}
      <Link to="/privacy-policy" className="underline hover:text-gray-700" data-id="element-877" data-mp="3dpjic96aktps">
        Privacy Policy
      </Link>
      , or{' '}
      <Link to="/do-not-sell-my-info" className="underline hover:text-gray-700" data-id="element-878" data-mp="3ipfnibqq6r6x">
        opt out of tracking and data sharing
      </Link>
      .
    </p>;
}